"use client"
import {
  FormControl
} from "./chunk-FW6Q6OAK.mjs";

// src/components/fieldset.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var Fieldset = mergeMultiStyle(
  FormControl,
  {
    baseStyle: {
      legend: {
        display: "block",
        fontSize: "md",
        fontWeight: "medium",
        mb: "2",
        me: "3",
        opacity: 1,
        transitionDuration: "normal",
        transitionProperty: "common",
        _disabled: {
          opacity: 0.4
        }
      }
    }
  }
)({ omit: ["label"] });

export {
  Fieldset
};
//# sourceMappingURL=chunk-5KY4TDPH.mjs.map